import { render } from "./form-upload-nko.vue?vue&type=template&id=55f264eb"
import script from "./form-upload-nko.vue?vue&type=script&lang=js"
export * from "./form-upload-nko.vue?vue&type=script&lang=js"
script.render = render

export default script